import { AlineTransforms, Queries } from '@aline/common';
import type { Editor } from 'slate';

export function clearStaleSuggestionMarkers(editor: Editor) {
  const removedSuggestionIds = removeStaleSuggestionMarkers(editor);
  return Boolean(removedSuggestionIds.length);
}

function removeStaleSuggestionMarkers(editor: Editor) {
  const sourcedGroupIds = Queries.getAllSourcedSuggestionGroupIds(editor);
  const staleMarkers = Queries.getAllSuggestionMarkers(editor).filter(
    marker => !sourcedGroupIds.has(marker.start.suggestionId)
  );
  const suggestionIds = staleMarkers.map(marker => marker.start.suggestionId);
  for (const suggestionId of suggestionIds.reverse()) {
    AlineTransforms.removeSuggestionMarkers(editor, suggestionId);
  }

  return suggestionIds;
}
